import React, { useState } from 'react';
import { handleAppDownload, openDemoBookingModal } from '../../utils/functions';

const AppsHub = () => {
  const [buyerPosition, setBuyerPosition] = useState(0);
  const [supplierPosition, setSupplierPosition] = useState(0);
  const [logisticsPosition, setLogisticsPosition] = useState(0);
  
  const buyerImages = 6;
  const supplierImages = 6;
  const logisticsImages = 6;

  const handlePrev = (type) => {
    if (type === 'buyer') {
      setBuyerPosition((prev) => (prev - 1 + buyerImages) % buyerImages);
    } else if (type === 'supplier') {
      setSupplierPosition((prev) => (prev - 1 + supplierImages) % supplierImages);
    } else if (type === 'logistics') {
      setLogisticsPosition((prev) => (prev - 1 + logisticsImages) % logisticsImages);
    }
  };

  const handleNext = (type) => {
    if (type === 'buyer') {
      setBuyerPosition((prev) => (prev + 1) % buyerImages);
    } else if (type === 'supplier') {
      setSupplierPosition((prev) => (prev + 1) % supplierImages);
    } else if (type === 'logistics') {
      setLogisticsPosition((prev) => (prev + 1) % logisticsImages);
    }
  };

  // Calculate transform based on viewport width and images per view
  const getTransform = (position, totalImages) => {
    if (typeof window === 'undefined') return 'translateX(0)';
    
    const viewport = window.innerWidth;
    let imagesPerView = 3; // Desktop default (3 images per view)
    let cardWidthPercent = 33.333; // Desktop: each card is ~33.33% width
    
    if (viewport < 768) {
      imagesPerView = 1; // Mobile: 1 image per view
      cardWidthPercent = 100; // Mobile: each card is 100% width
    } else if (viewport < 1024) {
      imagesPerView = 1; // Tablet: 1 image per view (based on CSS)
      cardWidthPercent = 100; // Tablet: each card is 100% width
    } else {
      imagesPerView = 3; // Desktop: 3 images per view
      cardWidthPercent = 33.333; // Desktop: each card is ~33.33% width (with gap)
    }
    
    // Calculate max position to prevent over-scrolling
    const maxPosition = Math.max(0, totalImages - imagesPerView);
    const clampedPosition = Math.min(position, maxPosition);
    
    // Move by card width percentage
    const translatePercent = clampedPosition * cardWidthPercent;
    
    return `translateX(-${translatePercent}%)`;
  };

  return (
    <>
      <section id="apps-hub" className="apps-hub-section">
        <div className="container">
          <div className="section-header apps-header">
            <div>
              <span className="section-badge">
                <i className="fas fa-mobile-alt"></i>
                BSB Tech Stack
              </span>
              <h2>BSB Integrated End-to-End Supply Chain Suite</h2>
            </div>
          </div>
        </div>
      </section>

      <section className="app-section app-section-buyer">
        <div className="container">
          <div className="bsb-app-row">
            <div className="bsb-app-content">
              <div className="app-logo">
                <img src="/assets/images/logo/polymer_white.webp" alt="BSB Polymer App" className="app-logo-img" />
              </div>
              <h3 className="app-subtitle">BSB Polymer App</h3>
              <ul className="app-highlights">
                <li><i className="fas fa-chart-line"></i> Real-time Prime & Recycle Rates</li>
                <li><i className="fas fa-truck"></i> Integrated Logistics & Freight Support</li>
                <li><i className="fas fa-credit-card"></i> Easy Credit Facility on One Platform</li>
                <li><i className="fas fa-bolt"></i> Instant Request Module (IRM)</li>
                <li><i className="fas fa-users"></i> Polyclub for Bulk Buying</li>
                <li><i className="fas fa-globe"></i> Web Portal Access</li>
                <li><i className="fas fa-microphone"></i> AI-Driven Voice & Chat Assistance</li>
              </ul>
              <div className="app-actions">
                <button className="btn btn-download-app" onClick={() => handleAppDownload('buyer')}>
                  <i className="fas fa-download"></i> Download App
                </button>
              </div>
            </div>
            <div className="bsb-app-slider" data-app="buyer">
              <div className="bsb-slider-wrapper">
                <div 
                  className="bsb-slider-track"
                  style={{
                    transform: getTransform(buyerPosition, buyerImages),
                    transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)'
                  }}
                >
                  <div className="bsb-img-card"><img src="/assets/images/Buyer_Prime/Front_View.webp" alt="Buyer App 1" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/Buyer_Prime/Home_Screen.webp" alt="Buyer App 2" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/Buyer_Prime/Home_Screen_2.webp" alt="Buyer App 3" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/Buyer_Prime/Filter.webp" alt="Buyer App 4" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/Buyer_Prime/IRM.webp" alt="Buyer App 5" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/Buyer_Prime/Transport.webp" alt="Buyer App 6" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/Buyer_Prime/Front_View.webp" alt="Buyer App 1" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/Buyer_Prime/Home_Screen.webp" alt="Buyer App 2" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/Buyer_Prime/Home_Screen_2.webp" alt="Buyer App 3" /></div>
                </div>
              </div>
              <div className="bsb-nav-buttons">
                <button className="bsb-nav prev" onClick={() => handlePrev('buyer')}><i className="fas fa-chevron-left"></i></button>
                <button className="bsb-nav next" onClick={() => handleNext('buyer')}><i className="fas fa-chevron-right"></i></button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="app-section app-section-supplier">
        <div className="container">
          <div className="bsb-app-row reverse">
            <div className="bsb-app-slider" data-app="supplier">
              <div className="bsb-slider-wrapper">
                <div 
                  className="bsb-slider-track"
                  style={{
                    transform: getTransform(supplierPosition, supplierImages),
                    transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)'
                  }}
                >
                  <div className="bsb-img-card"><img src="/assets/images/seller_prime/Front.webp" alt="Supplier App 1" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/seller_prime/home_screen.webp" alt="Supplier App 2" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/seller_prime/home_screen2.webp" alt="Supplier App 3" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/seller_prime/IRM.webp" alt="Supplier App 4" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/seller_prime/Logistic.webp" alt="Supplier App 5" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/seller_prime/Front.webp" alt="Supplier App 6" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/seller_prime/Front.webp" alt="Supplier App 1" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/seller_prime/home_screen.webp" alt="Supplier App 2" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/seller_prime/home_screen2.webp" alt="Supplier App 3" /></div>
                </div>
              </div>
              <div className="bsb-nav-buttons">
                <button className="bsb-nav prev" onClick={() => handlePrev('supplier')}><i className="fas fa-chevron-left"></i></button>
                <button className="bsb-nav next" onClick={() => handleNext('supplier')}><i className="fas fa-chevron-right"></i></button>
              </div>
            </div>
            <div className="bsb-app-content">
              <div className="app-logo">
                <img src="/assets/images/logo/polymer_partner.webp" alt="BSB Polymer Partners" className="app-logo-img" />
              </div>
              <h3 className="app-subtitle">BSB Polymer App <br /> (For Supplier)</h3>
              <ul className="app-highlights">
                <li><i className="fas fa-boxes"></i> Easy Inventory Listing & Updates</li>
                <li><i className="fas fa-bell"></i> Receive Instant Price Requests from Buyers</li>
                <li><i className="fas fa-users"></i> Polyclub for Bulk Selling to Multiple Buyers</li>
                <li><i className="fas fa-shipping-fast"></i> Integrated Logistics Business Opportunities</li>
                <li><i className="fas fa-globe"></i> Web Portal Access for Seamless Management</li>
                <li><i className="fas fa-microphone"></i> AI-Driven Voice & Chat Assistance</li>
              </ul>
              <div className="app-actions">
                <button className="btn btn-book-demo" onClick={() => openDemoBookingModal('polymer')}>
                  <i className="fas fa-calendar-check"></i> Book Demo
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="app-section app-section-logistics">
        <div className="container">
          <div className="bsb-app-row">
            <div className="bsb-app-content">
              <div className="app-logo">
                <img src="/assets/images/logo/logistic_white.webp" alt="BSB Logistics App" className="app-logo-img" />
              </div>
              <h3 className="app-subtitle">BSB Logistics App <br />(For Vendor)</h3>
              <ul className="app-highlights">
                <li><i className="fas fa-route"></i> Exclusive route-wise load and trip selection</li>
                <li><i className="fas fa-clock"></i> Receive real-time freight requirements</li>
                <li><i className="fas fa-file-invoice-dollar"></i> Submit freight quotations directly through the app</li>
                <li><i className="fas fa-truck-moving"></i> Update fleet details and vehicle availability instantly</li>
                <li><i className="fab fa-whatsapp"></i> Get instant notifications and alerts on WhatsApp</li>
                <li><i className="fas fa-microphone"></i> AI-powered Voice & Chat Assistant for smooth coordination</li>
              </ul>
              <div className="app-actions">
                <button className="btn btn-book-demo" onClick={() => openDemoBookingModal('logistics')}>
                  <i className="fas fa-calendar-check"></i> Book Demo
                </button>
              </div>
            </div>
            <div className="bsb-app-slider" data-app="logistics">
              <div className="bsb-slider-wrapper">
                <div 
                  className="bsb-slider-track"
                  style={{
                    transform: getTransform(logisticsPosition, logisticsImages),
                    transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)'
                  }}
                >
                  <div className="bsb-img-card"><img src="/assets/images/Logistic/Front.webp" alt="Logistic App 1" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/Logistic/home_inquiry.webp" alt="Logistic App 2" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/Logistic/driver_details.webp" alt="Logistic App 3" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/Logistic/truck_driver.webp" alt="Logistics App 4" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/Logistic/home_inquiry.webp" alt="Logistics App 5" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/Logistic/Front.webp" alt="Logistics App 6" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/Logistic/Front.webp" alt="Logistic App 1" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/Logistic/home_inquiry.webp" alt="Logistic App 2" /></div>
                  <div className="bsb-img-card"><img src="/assets/images/Logistic/driver_details.webp" alt="Logistic App 3" /></div>
                </div>
              </div>
              <div className="bsb-nav-buttons">
                <button className="bsb-nav prev" onClick={() => handlePrev('logistics')}><i className="fas fa-chevron-left"></i></button>
                <button className="bsb-nav next" onClick={() => handleNext('logistics')}><i className="fas fa-chevron-right"></i></button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AppsHub;

